import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePickupTemplate() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return settings;
}
